export default function respHandler(response) {
    if (!response.ok) {
        if (response.status === 401) {
            /*
             * We are redirecting any and all API calls that fail with a 401 to the Shibboleth login page. If attempting
             * to access any external APIs in the future, this logic will need to change as we will try to send the user
             * to the internal login page after an unauthenticated attempt to access data at that location.             *
             */
            let url = window.location.origin;
            url += '/Shibboleth.sso/Login?target=' + encodeURIComponent(window.location.href);
            window.location.assign(url);
            return;
        }
        if (response.status === 503 || response.status === 500) {
            try {
                return response.json();
            } catch {
                throw Error("" + response.status + " " + response.statusText);
            }
        }
        throw Error(response.statusText);
    }
    return response.json();
}